import { BreadcrumbsKey } from 'components/page/i18n/TModules';

export const translations = {
  [BreadcrumbsKey]: {
    Home: 'Home',
    Campaigns: 'Campagne',
    Customers: 'Clienti',
    List: 'Lista',
    LanguageSelector: 'Seleziona Lingua',
    Preference: 'Preferenze',
    Rewards: 'Premio',
    LevelUpMarketing: 'Marketing-Aumento',
    Info: 'Info',
    Audience: 'Audience',
    Mechanics: 'Mecanica',
    Review: 'Riview'
  }
};
